import api from './api';
import { API_ENDPOINTS } from './endpoints';

export interface FeatureFlagResponse {
  name: string;
  enabled: boolean;
}

export const featureFlagsService = {
  getFlag: async (name: string) => {
    return await api.get<FeatureFlagResponse | { data: FeatureFlagResponse }>(
      API_ENDPOINTS.FEATURE_FLAGS.INDEX(name)
    );
  },

  updateFlag: async (name: string, enabled: boolean) => {
    return await api.put<FeatureFlagResponse | { data: FeatureFlagResponse }>(
      API_ENDPOINTS.FEATURE_FLAGS.INDEX(name),
      { enabled }
    );
  },
};
